export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  balance: (state) => state.balance,
};
